<div class="d-flex mat-elevated-item justify-content-between border rounded s-p-5 s-gap-c-5 card-shadow h-100">
  <div class="d-flex flex-column justify-content-between w-100">

    <div class="d-flex justify-content-between align-items-start w-100">
      <span class="s-large">{{ title() | emptyValue : true }}</span>

      <div class="d-flex align-items-start s-gap-c-1" *ngIf="icon() || true">
        <ng-content select="[card-actions]"></ng-content>
      </div>
    </div>

    <ng-container *ngIf="showValue(); else customContent">
      <h2 class="s-mt-20">{{ value() | emptyValue }}</h2>
    </ng-container>

    <ng-template #customContent>
      <div class="s-mt-6">
        <ng-content></ng-content>
      </div>
    </ng-template>
  </div>

  <div *ngIf="icon()" class="d-flex flex-column">
    <div class="s-p-1 s-ps-2 s-pe-2 c-white border rounded border-crl-transparent"
      [ngStyle]="{ 'background-color': iconBackground() }">
      <mat-icon> {{ icon() }} </mat-icon>
    </div>
  </div>
</div>